module.exports = __webpack_public_path__ + "static/media/intro_logo.7baa9a80.svg";